import React, { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormProvider } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { useProductMutation } from 'hooks/useProductHook';
import ProductHeader from './ProductHeader';
import ProductFooter from './ProductFooter';
import ProductType from './ProductType';
import Article from './Article';
import ProductPricing from './ProductPricing';
import ProductPricingRef from './ProductPricingRef';
import Financing from './Financing';
import SubProducts from './SubProducts';
import RecipeHeader from './RecipeHeader';
import Composition from './Composition';
import ProductUpload from './ProductUpload';
import ProductSpecifications from './ProductSpecifications';
import ProductDescriptions from './ProductDescriptions';

const AddProduct = () => {
 const { type, methods, onSubmit, handleSubmit, onError, article, articles } = useProductMutation();

 const [searchParams, setSearchParams] = useSearchParams();

 useEffect(() => {
  if (!searchParams.get('type')) searchParams.set('type', 'product');
  setSearchParams(searchParams);
 }, [searchParams, setSearchParams]);

 return (
  <FormProvider {...methods}>
   <Form onSubmit={handleSubmit(onSubmit, onError)}>
    <Row className="g-3">
     <Col xs={12}>
      <ProductHeader />
     </Col>
     <Col lg={8}>
      {type === 'product' ? (
       <>
        <Article article={article} articles={articles} />
        <ProductPricing article={article} />
        {article?.code ? <ProductPricingRef article={article} /> : <></>}
        <Financing />
        {article?.code ? <SubProducts article={article} /> : <></>}
       </>
      ) : (
       <>
        <RecipeHeader />
        <Composition item={article} items={articles} />
        <Financing />
        <ProductUpload />
        <ProductSpecifications />
       </>
      )}

      <ProductDescriptions />
     </Col>
     <Col lg={4}>
      <div className="sticky-sidebar">
       <ProductType />
      </div>
     </Col>
     <Col>
      <ProductFooter />
     </Col>
    </Row>
   </Form>
  </FormProvider>
 );
};

export default AddProduct;
